import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NewmemberService } from '../../services/newmember.service';
import { MessageService } from 'primeng/api';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogService } from 'primeng/api';
import { ImagepreviewComponent } from '../imagepreview/imagepreview.component';
import { WebcamComponent } from '../webcam/webcam.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-docupload',
  templateUrl: './docupload.component.html',
  styleUrls: ['./docupload.component.css']
})
export class DocuploadComponent implements OnInit {
  inProgress = 0;
  formatAllowed = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
  selectedFiles: any = [];
  uploadedFiles: any = [];
  uploadProcess: any;
  documentIdInput: number;
  totalCountInput: number;

  @Input() documentId;
  @Input() type;
  @Input() typename;
  @Input() totalCount;
  @Input() limit;
  @Input() showError;
  @Input() disabled;
  @Output() changeResponse = new EventEmitter();
  @Output() uploadResponse = new EventEmitter();

  constructor(public nms: NewmemberService,
    private messageService: MessageService,
    public sanitizer: DomSanitizer,
    public dialogService: DialogService) {
  }

  ngOnInit() {
    if (this.documentId === 0) {
      this.documentIdInput = 0;
    } else {
      this.documentIdInput = this.documentId;
    }
    if (this.totalCount === 0) {
      this.totalCountInput = 0;
    } else {
      this.totalCountInput = this.totalCount;
    }
  }

  public reset() {
    this.documentIdInput = 0;
    this.totalCountInput = 0;
  }

  public reinit() {
    if (this.documentId === 0) {
      this.documentIdInput = 0;
    } else {
      this.documentIdInput = this.documentId;
    }
    if (this.totalCount === 0) {
      this.totalCountInput = 0;
    } else {
      this.totalCountInput = this.totalCount;
    }
  }

  public sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public updateCount(event) {
    for (let file of event.files) {
      let pass = 0;
      for (let format of this.formatAllowed) {
        if (format === file.type && (this.type != 'PHOTO' || file.type != 'application/pdf')) {
          pass = 1;
        }
      }
      if (pass === 0) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Document Upload Status',
          detail: 'This file format is not allowed'
        });
        return;
      }
      if (file.size > 1000000) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Document Upload Status',
          detail: 'File size limit is 1MB'
        });
        return;
      }
    }
    if ((this.totalCountInput + event.files.length) <= this.limit) {
      this.totalCountInput = this.totalCountInput + event.files.length;
      for (let file of event.files) {
        if (!file.objectURL) {
          this.fileToUrl(file).subscribe((data: any) => {
            if (data) {
              file.url = data;
              this.selectedFiles.push(file);
            }
          });
        } else {
          this.selectedFiles.push(file);
        }
      }
      this.changeResponse.emit(false);
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Document Upload Status',
        detail: 'Limit of upload is ' + this.limit
      });
    }
  }

  public captureImg() {
    const ref = this.dialogService.open(WebcamComponent, {
      header: 'Capture Image',
      width: '85%',
      closeOnEscape: false
    });
    ref.onClose.subscribe((data: any) => {
      if (data) {
        let pass = 0;
        for (let format of this.formatAllowed) {
          if (format === data._mimeType) {
            pass = 1;
          }
        }
        if (pass === 0) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Document Upload Status',
            detail: 'This file format is not allowed'
          });
          return;
        }
        if ((this.totalCountInput + 1) <= this.limit) {
          this.changeResponse.emit(false);
          this.totalCountInput = this.totalCountInput + 1;
          let temp = this.covertBlob(data.imageAsDataUrl, data._mimeType);
          //temp.url = URL.createObjectURL(data.imageAsDataUrl);
          //let temp = {'url': data.imageAsDataUrl, 'type': data._mimeType}
          this.selectedFiles.push(temp); // imageAsBase64
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Document Upload Status',
            detail: 'Limit of upload is ' + this.limit
          });
        }
      }
    });
  }

  public covertBlob(dataURI, contentType) {
    // var byteString = atob(dataURI.split(',')[1]);
    // var ab = new ArrayBuffer(byteString.length);
    // var ia = new Uint8Array(ab);
    // for (var i = 0; i < byteString.length; i++) {
    //     ia[i] = byteString.charCodeAt(i);
    // }
    // var bb = new Blob([ab], {type: contentType});
    // return bb;
    let arr = dataURI.split(','), bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    let temp = '' + Math.random();
    return new File([u8arr], temp, { type: contentType });
  }

  public resetWithValue(documentId, count, type) {
    this.documentIdInput = documentId;
    this.totalCountInput = count;
    this.type = type;
    this.typename = type;
  }

  public uploadFiles(form) {
    if (this.selectedFiles.length !== 0) {
      this.inProgress = 1;
      this.uploadProcess = this.nms.uploadDoc(this.selectedFiles, this.type, this.documentIdInput).subscribe((res: any) => {
        
        this.inProgress = 0;
        if (res.code === 'SUCCESS') {
          this.documentIdInput = res.response.documentId;
          for (let file of this.selectedFiles) {
            this.uploadedFiles.push(file);
          }
          for (let i = 0; i < this.uploadedFiles.length; i++) {
            for (let j = 0; j < res.response.vaultinfo.length; j++) {
              if (this.uploadedFiles[i].name === res.response.vaultinfo[j].fileName) {
                this.uploadedFiles[i].vaultId = res.response.vaultinfo[j].vaultId;
              }
            }
          }
          this.selectedFiles = [];
          this.changeResponse.emit(true);
          this.uploadResponse.emit({ documentId: this.documentIdInput, noOfPages: this.totalCountInput });
          this.messageService.add({
            severity: 'success',
            summary: 'Document Upload Status',
            detail: 'File uploaded successfully'
          });
          form.clear();
        }
      }, err => {
        this.inProgress = 0;
        console.error('ERROR', err);
      });
    } else {
      this.messageService.add({
        severity: 'warn', summary: 'Document Upload Status',
        detail: 'No changes made. Existing documents have already been uploaded.'
      });
    }
  }

  public cancelUpload() {
    this.uploadProcess.unsubscribe();
    this.inProgress = 0;
  }

  public fileToUrl(s) {
    return new Observable((observer) => {
      var reader = new FileReader();
      reader.readAsDataURL(s);
      reader.onload = function () {
        observer.next(reader.result);
      };
    });
  }

  public imgPreview() {
    if (this.totalCountInput !== 0) {
      let sTemp = [];
      for (let s of this.selectedFiles) {
        let temp: any = {};
        if (!s.objectURL) {
          if (s.type == 'application/pdf') {
            temp = s;
          } else {
            temp.blob = URL.createObjectURL(s);
          }
          temp.fileType = s.type;
          sTemp.push(temp);
        } else {
          temp.blob = s.objectURL.changingThisBreaksApplicationSecurity;
          temp.fileType = s.type;
          sTemp.push(temp);
        }
      }
      let data: any = {};
      data.documentId = this.documentIdInput;
      data.uploaded = JSON.parse(JSON.stringify(this.uploadedFiles));
      data.selected = JSON.parse(JSON.stringify(sTemp));
      
      const ref = this.dialogService.open(ImagepreviewComponent, {
        data: data,
        header: this.typename,
        width: '85%',
        closeOnEscape: false
      });
      ref.onClose.subscribe((data: any) => {
        if (data) {
          this.totalCountInput = data.uploadedFiles.length + data.selectedFiles.length;
          if (data.uploadedFiles.length === 0) {
            this.documentIdInput = 0;
            this.uploadedFiles = [];
            this.changeResponse.emit(false);
            this.uploadResponse.emit({ documentId: 0, noOfPages: 0 });
          }
          if (data.selectedFiles.length === 0) {
            this.selectedFiles = [];
          }
          for (let i of data.uploadedSplice) {
            this.uploadedFiles.splice(i, 1);
          }
          for (let i of data.selectedSplice) {
            this.selectedFiles.splice(i, 1);
          }
        }
      });
    }
  }

}
